export default __webpack_public_path__ + "static/media/3.6a019bc1.jpg";